import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import axios from "axios";
import { hostname } from "src/HostName";
import { useSnackbar } from "notistack5";
import CustomModalComp from "src/components/CustomComponents/CustomModalComp";
import { Col, Row } from "react-bootstrap";
const ReplicaSupplierComp = ({ agentData, provd, metaId, userRole }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userId, setUserId] = useState([]);
  const [loading, setloading] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleReplica = async () => {
    const LoginData = localStorage.getItem("LoginData");
    const user = JSON.parse(LoginData);
    if (loading || userId.length === 0) return;
    setloading(true);
    try {
      const { data } = await axios.post(`${hostname}replica/supplier`, {
        userid: userId,
        supplier_data: provd,
        loginUser: user?.userid,
        metaId: metaId,
      });
      if (data.statusCode === 200) {
        setAnchorEl(false);
        setUserId([]);
      }
      enqueueSnackbar(data.message, {
        variant: data.statusCode === 200 ? "success" : "error",
      });
    } catch (error) {}
    setloading(false);
  };
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <FormControlLabel
        label="Replica"
        control={
          <IconButton color="secondary" onClick={handleClick}>
            <ContentCopyRoundedIcon />
          </IconButton>
        }
      />
      <CustomModalComp
        show={open}
        onHide={() => {
          setAnchorEl(false);
          setUserId([]);
        }}
        title={`Add Replica (${provd.name})`}
      >
        <div
          style={{ maxHeight: "50vh", position: "relative", overflowY: "auto" }}
        >
          <FormGroup className="px-3">
            <Row>
              {agentData
                .filter((el) =>
                  userRole === "superAdmin" ? true : el.type !== "site",
                )
                .map((it) => (
                  <Col xl={3}>
                    <FormControlLabel
                      key={it.userid}
                      control={
                        <Checkbox
                          value={it.userid}
                          onChange={(e) => {
                            const { checked, value } = e.target;
                            if (checked) {
                              setUserId([...userId, value]);
                            } else {
                              setUserId(userId.filter((el) => el !== value));
                            }
                          }}
                        />
                      }
                      label={it.username}
                    />{" "}
                  </Col>
                ))}
            </Row>{" "}
          </FormGroup>
          <div className=" position-sticky bottom-0 text-center bg-white p-2">
            <Button
              onClick={handleReplica}
              variant="outlined"
              disabled={loading}
            >
              {loading ? "Please Wait" : "Submit"}
            </Button>
          </div>
        </div>
      </CustomModalComp>
    </div>
  );
};

export default ReplicaSupplierComp;
